import React, { useEffect, useState, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SnackBarStoreAction } from "Store/SnackBar";
import BackdropComponent from "../../Spinner/Spinner";
import PropTypes from "prop-types";
import SnackBar from "components/SnackBar/SnackBar";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { bulkEditStoreAction } from "../../../Store/BulkEdit";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import PowerSharpIcon from "@mui/icons-material/PowerSharp";
import LastUpdateTooltip from "../Helpers/LastUpdateTooltip";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import {
  Box,
  Button,
  Typography,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  TextField,
  InputAdornment,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import classes from "./ClassData.module.css";
import Modal from "@mui/material/Modal";
import SearchModal from "../../RosterConfigComponents/SearchModal/SearchModal";
import applicationUsageLog from "../../../utils/applicationUsagesLog";

import {
  getClassData,
  saveBulkEditClassData,
} from "../../../services/userServices";

const getFilteredData = (data, property, value) =>
  data.filter((item) => item[property] === value);

const CustomButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  color: "white",
  marginTop: "-10px",
  backgroundColor: "#3299FF",
  "&:hover": {
    backgroundColor: "#2878CC",
  },
}));
const CustomOutlinedButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  borderColor: "#3299FF",
  color: "#3299FF",
  marginTop: "-10px",
  "&:hover": {
    borderColor: "#3299FF",
    backgroundColor: "#E0F2FF",
  },
}));

const searchTrainerStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const ClassData = (props) => {
  const { t } = useTranslation(["class"]);
  const classTraineeId = useSelector((state) => state.bulkEdit);
  const { classRequestId, classRosterId } = classTraineeId;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sortFlag, setSortFlag] = useState({});
  const [classData, setClassData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [order, setOrder] = useState("ASC");
  const [searchType, setSearchType] = useState("");
  const [oracleId, setOracleId] = useState("");
  const [traineeStatus, setTraineeStatus] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [agentComments, setAgentComments] = useState("");
  const initialRender = useRef(true);
  const ttdType = ["", "BOT", "ASD", "Client Equip."];
  const [ttdTypeAll, setTtdTypeAll] = useState("");

  const [globalValue, setGlobalValue] = useState({
    TrainingSpace: "",
    OGTeamEmail: "",
    TrainerName: "",
    TrainerEmail: "",
    OGName: "",
    OGEmail: "",
    FDOName: "",
    FDOEmail: "",
    OperationalTeamLeadName: "",
    OperationalTeamLeadEmail: "",
    NestingTeamLead: "",
    NestingTeamLeadEmail: "",
    ProductTrainingZoomLink: "",
    TechTestZoomLink: "",
    TechTestRecoveryZoomLink: "",
  });

  const searchTrainerFields = {
    nameField: "",
    emailField: "",
    idField: "",
  };
  const [totalActiveCount, setTotalActiveCount] = useState({
    total: 0,
    active: 0,
  });

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const [globalDate, setGlobalDate] = useState({
    NestingDate: "",
    NestingTime: "",
    NestingEndDate: "",
    NestingEndTime: "",
    ProductTrainingDate: "",
    ProductTrainingTime: "",
    ttdDate: "",
    ttdRecoverDate: "",
  });

  useEffect(() => {
    applicationUsageLog(
      localStorage.getItem("User"),
      localStorage.getItem("EmailId"),
      "ASTT",
      "Class",
    );
  }, []);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      setLoading(true);

      const timeout = setTimeout(() => {
        filtering(props.filterStatus, filterData);
        setLoading(false);
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [props.filterStatus]);

  useEffect(() => {
    let cancelled = false;

    const handleReset = async () => {
      try {
        await fetchData();

        if (cancelled) return;

        if (props.resetStatus === true) {
          // Cloning as a writable object
          const allDataClone = JSON.parse(JSON.stringify(allData));

          // Merge trainee data with all data
          for (let data of allDataClone) {
            for (let trainee of filterData) {
              if (data.OracleId === trainee.OracleId) {
                data.TrainerName = trainee.TrainerName;
                data.TrainerEmail = trainee.TrainerEmail;
                data.OGName = trainee.OGName;
                data.OGEmail = trainee.OGEmail;
                data.FDOName = trainee.FDOName;
                data.FDOEmail = trainee.FDOEmail;
                data.OperationalTeamLead = trainee.OperationalTeamLead;
                data.OperationalTeamEmail = trainee.OperationalTeamLeadEmail;
                data.NestingTeamLead = trainee.NestingTeamLead;
                data.NestingTeamLeadEmail = trainee.NestingTeamLeadEmail;
              }
            }
          }

          if (!cancelled) {
            setClassData(allDataClone);
            setFilterData(allDataClone);
            setTtdTypeAll("");
            props.onChange();
            setAgentComments("");
            setGlobalDate({
              NestingDate: "",
              NestingTime: "",
              NestingEndDate: "",
              NestingEndTime: "",
              ProductTrainingDate: "",
              ProductTrainingTime: "",
              ttdDate: "",
              ttdRecoverDate: "",
            });
            setGlobalValue({
              TrainingSpace: "",
              OGTeamEmail: "",
              TrainerName: "",
              TrainerEmail: "",
              OGName: "",
              OGEmail: "",
              FDOName: "",
              FDOEmail: "",
              OperationalTeamLeadName: "",
              OperationalTeamLeadEmail: "",
              NestingTeamLead: "",
              NestingTeamLeadEmail: "",
              ProductTrainingZoomLink: "",
              TechTestZoomLink: "",
              TechTestRecoveryZoomLink: "",
            });
            filtering(props.filterStatus, allData);
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to handle reset:", error);
        }
      }
    };

    handleReset();

    return () => {
      cancelled = true;
    };
  }, [props.resetStatus]);

  const sorting = (col) => {
    if (order === "ASC") {
      const sorted = [...classData].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1,
      );
      setClassData(sorted);
      setOrder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...classData].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1,
      );
      setClassData(sorted);
      setOrder("ASC");
    }
  };

  const filtering = (filter, data) => {
    let filterData = [];

    if (filter === "ALL") {
      filterData = data;
    } else {
      filterData = data.filter(
        (item) => item.TraineeStatus === props.filterStatus,
      );
    }
    setClassData(filterData);
    initialCheck(filterData);
    props.closeLoader();
  };

  const initialCheck = (data) => {
    let activeCount = getFilteredData(data, "TraineeStatus", "Active");
    setTotalActiveCount({
      total: data.length,
      active: activeCount.length,
    });
  };

  const fetchData = useCallback(async () => {
    setLoading(true);

    let obj = {
      classTraineeIdList: classTraineeId.traineeDetails,
    };
    const response = await getClassData(obj);
    if (response.message === "Success") {
      let data = response.data.map((item) => ({
        ...item,
        NestingDate:
          item.NestingDate && item.NestingTime
            ? formatDateTime(item.NestingDate, item.NestingTime || "00:00")
            : null,
        NestingEndDate:
          item.NestingEndDate && item.NestingEndTime
            ? formatDateTime(
                item.NestingEndDate,
                item.NestingEndTime || "00:00",
              )
            : null,
        ProductTrainingDate:
          item.ProductTrainingDate && item.ProductTrainingTime
            ? formatDateTime(
                item.ProductTrainingDate,
                item.ProductTrainingTime || "00:00",
              )
            : null,
        ttdDate:
          item.TechTestDate && item.TechTestTime
            ? formatDateTime(item.TechTestDate, item.TechTestTime || "00:00")
            : null,
        ttdRecoverDate:
          item.TechTestRecoveryDate && item.TechTestRecoveryTime
            ? formatDateTime(
                item.TechTestRecoveryDate,
                item.TechTestRecoveryTime || "00:00",
              )
            : null,
      }));

      setAllData(data);
      setClassData(data);
      setFilterData(data);
      dispatch(bulkEditStoreAction.setClassData(data));
      dispatch(bulkEditStoreAction.setClassAllData(data));

      if (response.data) {
        filtering(props.filterStatus, data);
      }
    } else {
      setSnack({
        open: true,
        message: "Failed to load data!",
        severity: "error",
      });
    }

    setLoading(false);
  }, [classTraineeId.traineeDetails, dispatch, filtering, props.filterStatus]);

  const filterTrainerGlobal = (sourceData, data, searchTrainerFields) => {
    return sourceData.map((item) => {
      if (
        props.filterStatus === "ALL" ||
        props.filterStatus === item.TraineeStatus
      )
        return {
          ...item,
          [searchTrainerFields.nameField]: data.Name,
          [searchTrainerFields.emailField]: data.Email,
          [searchTrainerFields.idField]: data.OracleId,
        };
      else
        return {
          ...item,
        };
    });
  };

  const filterTrainerSingle = (sourceData, data, searchTrainerFields) => {
    return sourceData.map((item) => {
      if (item.OracleId === oracleId && item.TraineeStatus === traineeStatus)
        return {
          ...item,
          [searchTrainerFields.nameField]: data.Name,
          [searchTrainerFields.emailField]: data.Email,
          [searchTrainerFields.idField]: data.OracleId,
        };
      else
        return {
          ...item,
        };
    });
  };

  const formatDateTime = (dateString, timeString) =>
    moment(`${dateString} ${timeString}`, "YYYY-MM-DD HH:mm").format(
      "YYYY-MM-DDTHH:mm",
    );

  const handleSearchTrainerClose = (data, searchType) => {
    if (!searchType) {
      setModalOpen(false);
      return;
    }

    const setTypeValue = (value) => {
      setGlobalValue(value);
      searchTrainerFields.nameField = value.nameField;
      searchTrainerFields.emailField = value.emailField;
      searchTrainerFields.idField = value.idField;
    };

    const setTypeValueAndFilter = (value) => {
      setTypeValue(value);
      const record = filterTrainerGlobal(filterData, data, searchTrainerFields);
      const trainee = filterTrainerGlobal(classData, data, searchTrainerFields);
      setClassData(trainee);
      setFilterData(record);
      setModalOpen(false);
      dispatch(bulkEditStoreAction.setClassData(trainee));
    };

    const setTypeValueAndFilterSingle = (value) => {
      setTypeValue(value);
      const record = filterTrainerSingle(filterData, data, searchTrainerFields);
      const trainee = filterTrainerSingle(classData, data, searchTrainerFields);
      setClassData(trainee);
      setFilterData(record);
      setModalOpen(false);
      dispatch(bulkEditStoreAction.setClassData(trainee));
    };

    const typeValues = {
      trainerGlobal: {
        nameField: "TrainerName",
        emailField: "TrainerEmail",
        idField: "TrainerId",
      },
      ogGlobal: {
        nameField: "OGName",
        emailField: "OGEmail",
        idField: "OGId",
      },
      fdoGlobal: {
        nameField: "FDOName",
        emailField: "FDOEmail",
        idField: "FDOId",
      },
      tpcGlobal: {
        nameField: "OperationalTeamLead",
        emailField: "OperationalTeamLeadEmail",
        idField: "OperationalId",
      },
      nstGlobal: {
        nameField: "NestingTeamLead",
        emailField: "NestingTeamLeadEmail",
        idField: "NestingTeamLeadId",
      },
      trainerSingle: {
        nameField: "TrainerName",
        emailField: "TrainerEmail",
        idField: "TrainerId",
      },
      ogSingle: {
        nameField: "OGName",
        emailField: "OGEmail",
        idField: "OGId",
      },
      fdoSingle: {
        nameField: "FDOName",
        emailField: "FDOEmail",
        idField: "FDOId",
      },
      tpcSingle: {
        nameField: "OperationalTeamLead",
        emailField: "OperationalTeamLeadEmail",
        idField: "OperationalId",
      },
      nstSingle: {
        nameField: "NestingTeamLead",
        emailField: "NestingTeamLeadEmail",
        idField: "NestingTeamLeadId",
      },
    };

    if (searchType.includes("Global")) {
      setTypeValueAndFilter(typeValues[searchType]);
    } else {
      setTypeValueAndFilterSingle(typeValues[searchType]);
    }
  };

  const filterEmptySearchBox = (data, searchTrainerFields) => {
    return data.map((item, index) => {
      if (
        props.filterStatus === "ALL" ||
        item.TraineeStatus === props.filterStatus
      )
        return {
          ...item,
          [searchTrainerFields.nameField]:
            allData[index][searchTrainerFields.nameField],
          [searchTrainerFields.emailField]:
            allData[index][searchTrainerFields.emailField],
          [searchTrainerFields.idField]: null,
        };
      else
        return {
          ...item,
        };
    });
  };

  const emptyAllSearchBox = (searchType) => {
    let record = [];
    let trainee = [];
    if (searchType === "trainerGlobal") {
      setGlobalValue({
        TrainerName: ``,
        TrainerId: null,
      });

      searchTrainerFields.nameField = "TrainerName";
      searchTrainerFields.emailField = "TrainerEmail";
      searchTrainerFields.idField = "TrainerId";
    }

    if (searchType === "ogGlobal") {
      setGlobalValue({
        OGName: ``,
      });

      searchTrainerFields.nameField = "OGName";
      searchTrainerFields.emailField = "OGEmail";
      searchTrainerFields.idField = "OGId";
    }

    if (searchType === "fdoGlobal") {
      setGlobalValue({
        FDOName: ``,
      });

      searchTrainerFields.nameField = "FDOName";
      searchTrainerFields.emailField = "FDOEmail";
      searchTrainerFields.idField = "FDOId";
    }

    if (searchType === "tpcGlobal") {
      setGlobalValue({
        OperationalTeamLeadName: ``,
      });

      searchTrainerFields.nameField = "OperationalTeamLead";
      searchTrainerFields.emailField = "OperationalTeamLeadEmail";
      searchTrainerFields.idField = "OperationalId";
    }

    if (searchType === "nstGlobal") {
      setGlobalValue({
        NestingTeamLead: ``,
      });

      searchTrainerFields.nameField = "NestingTeamLead";
      searchTrainerFields.emailField = "NestingTeamLeadEmail";
      searchTrainerFields.idField = "NestingTeamLeadId";
    }

    record = filterEmptySearchBox(filterData, searchTrainerFields);
    trainee = filterEmptySearchBox(classData, searchTrainerFields);

    setClassData(trainee);
    setFilterData(record);
    setModalOpen(false);
    dispatch(bulkEditStoreAction.setClassData(trainee));
  };

  const handleOpenSearchTrainer = (type) => {
    setSearchType(type);
    setModalOpen(true);
  };

  const handleOpenSearchTrainerIndividual = (
    type,
    index,
    oracleId,
    traineeStatus,
  ) => {
    setSearchType(type);
    setOracleId(oracleId);
    setTraineeStatus(traineeStatus);
    setModalOpen(true);
  };

  const handleGlobalDateChange = (event, key) => {
    setGlobalDate({
      ...globalDate,
      [key]: event,
    });
    if (event === "" || event === " ") {
      let data = filterData.map((item, i) => {
        return item.OracleId === allData[i].OracleId
          ? { ...item, [key]: allData[i][key] }
          : null;
      });
      setFilterData(data);
      let oldClassData = classData.map((item) => {
        const initial = allData.find((data) => data.OracleId === item.OracleId);
        if (initial) {
          return {
            ...item,
            [key]: initial[key],
          };
        }
        return item;
      });
      setClassData(oldClassData);
      dispatch(bulkEditStoreAction.setClassData(oldClassData));
    } else {
      let data = filterData.map((item) => {
        if (
          props.filterStatus === "ALL" ||
          props.filterStatus === item.TraineeStatus
        )
          return {
            ...item,
            [key]: event,
          };
        else
          return {
            ...item,
          };
      });

      let traineFilter = classData.map((item) => {
        return {
          ...item,
          [key]: event,
        };
      });

      setClassData(traineFilter);
      setFilterData(data);
      dispatch(bulkEditStoreAction.setClassData(traineFilter));
    }
  };

  const handlgeGlobalValue = (event, key) => {
    const value = event.target.value;

    setGlobalValue({
      [key]: value,
    });

    let data = filterData.map((item, i) => {
      if (value === "" || value === " ") {
        if (item.OracleId === allData[i].OracleId) {
          return {
            ...item,
            [key]: allData[i][key] === "" ? null : allData[i][key],
          };
        }
      } else if (
        props.filterStatus === "ALL" ||
        props.filterStatus === item.TraineeStatus
      ) {
        return {
          ...item,
          [key]: value,
        };
      }

      return item;
    });

    let traineFilter = classData.map((item) => ({
      ...item,
      [key]: value,
    }));

    setFilterData(data);
    setClassData(traineFilter);
    dispatch(bulkEditStoreAction.setClassData(traineFilter));
  };

  const handleIndividualDateChange = (event, row, key) => {
    let data = filterData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event,
        };
      } else {
        return item;
      }
    });

    let trainee = classData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event,
        };
      } else {
        return item;
      }
    });
    setClassData(trainee);
    setFilterData(data);
    dispatch(bulkEditStoreAction.setClassData(data));
    filtering(props.filterStatus, data);
  };

  const hanldeIndividualChange = (event, row, key) => {
    let data = filterData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event.target.value,
        };
      } else {
        return item;
      }
    });

    let trainee = classData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event.target.value === "" ? null : event.target.value,
        };
      } else {
        return item;
      }
    });

    setClassData(trainee);
    dispatch(bulkEditStoreAction.setClassData(trainee));
    setFilterData(data);
  };

  const renderTextCell = (nameWithId, traineeStatus, isInactive) => (
    <Grid item xs={0.6} align="center">
      <p className={isInactive ? "text-decoration-line-bulk" : null}>
        {nameWithId}
      </p>
      {isInactive && <p className={classes.blueColor}>{traineeStatus}</p>}
    </Grid>
  );

  const handleIndividualText = (event, row, key) => {
    let data = filterData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event.target.value,
        };
      } else {
        return item;
      }
    });
    let trainee = classData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event.target.value === "" ? null : event.target.value,
        };
      } else {
        return item;
      }
    });
    setClassData(trainee);
    setFilterData(data);
    dispatch(bulkEditStoreAction.setClassData(trainee));
  };

  const formatNestingDate = (dateString) => {
    if (dateString === null || dateString === undefined) {
      return null;
    }
    return moment(new Date(dateString)).isValid()
      ? moment(new Date(dateString)).format("YYYY-MM-DD HH:mm")
      : null;
  };

  const formatNestingDateTime = (dateString) => {
    if (dateString === null || dateString === undefined) {
      return null;
    }
    return moment(new Date(dateString)).isValid()
      ? moment(new Date(dateString)).format("HH:mm")
      : null;
  };

  const saveClassData = async (e) => {
    setLoading(true);
    const obj = createData();
    const response = await saveBulkEditClassData(obj);
    if (response.message === "Success") {
      setSnack({
        open: true,
        message: "Update completed successfully.",
        severity: "success",
      });
      setLoading(false);
      setAgentComments("");
      setTtdTypeAll("");
      setGlobalDate({
        NestingDate: "",
        NestingTime: "",
        NestingEndDate: "",
        NestingEndTime: "",
        ProductTrainingDate: "",
        ProductTrainingTime: "",
        ttdDate: "",
        ttdRecoverDate: "",
      });
      setGlobalValue({
        TrainingSpace: "",
        OGTeamEmail: "",
        TrainerName: "",
        TrainerEmail: "",
        OGName: "",
        OGEmail: "",
        FDOName: "",
        FDOEmail: "",
        OperationalTeamLeadName: "",
        OperationalTeamLeadEmail: "",
        NestingTeamLead: "",
        NestingTeamLeadEmail: "",
        ProductTrainingZoomLink: "",
        TechTestZoomLink: "",
        TechTestRecoveryZoomLink: "",
      });

      fetchData();
    } else {
      setLoading(false);
      setSnack({
        open: true,
        message: "Failed to apply changes.",
        severity: "error",
      });
    }

    setLoading(false);
  };

  const saveCloseHandler = async (e) => {
    setLoading(true);
    const obj = createData();
    const response = await saveBulkEditClassData(obj);
    if (response.message === "Success") {
      const obj = {
        open: true,
        message: "Update completed successfully.",
        severity: "success",
      };
      dispatch(bulkEditStoreAction.setPreviousTabName(""));
      dispatch(SnackBarStoreAction.updateSnack(obj));
      navigateBack();
    } else {
      setSnack({
        open: true,
        message: "Failed to apply changes.",
        severity: "error",
      });
    }
  };

  const createData = () => {
    const obj = classData.map((item) => {
      return {
        classTraineeId: item.ClassTraineeId,
        agentComments: item.AgentComments,
        nestingDate: formatNestingDate(item.NestingDate),
        nestingTime: formatNestingDateTime(item.NestingDate),
        nestingEndDate: formatNestingDate(item.NestingEndDate),
        nestingEndTime: formatNestingDateTime(item.NestingEndDate),
        ogName: item.OGId,
        fdoName: item.FDOId,
        ogTeamEmail: item.OGTeamEmail,
        operationalTeamLead: item.OperationalId || item.OperationalTeamLeadId,
        nestingTeamLead: item.NestingTeamLeadId,
        productTrainingDate:
          item.ProductTrainingDate !== "YYYY-MM-DDTHH:mm"
            ? moment(new Date(item.ProductTrainingDate)).format("YYYY-MM-DD")
            : null,
        productTrainingTime:
          item.ProductTrainingDate !== "YYYY-MM-DDTHH:mm"
            ? moment(new Date(item.ProductTrainingDate)).format("HH:mm")
            : null,
        productTrainingZoomLink: item.ProductTrainingZoomLink,
        techTestType: item.TechTestType,
        asdLead: item.ASDLead,
        failureReason: item.FailureReason,
        techTestDate:
          item.ttdDate !== "YYYY-MM-DDTHH:mm"
            ? moment(new Date(item.ttdDate)).format("YYYY-MM-DD")
            : null,
        techTestTime:
          item.ttdDate !== "YYYY-MM-DDTHH:mm"
            ? moment(new Date(item.ttdDate)).format("HH:mm")
            : null,
        techTestZoomLink: item.TechTestZoomLink,
        techTestRecoveryZoomLink: item.TechTestRecoveryZoomLink,
        techTestRecoveryDate:
          item.ttdRecoverDate !== "YYYY-MM-DDTHH:mm"
            ? moment(new Date(item.ttdRecoverDate)).format("YYYY-MM-DD")
            : null,
        techTestRecoveryTime:
          item.ttdRecoverDate !== "YYYY-MM-DDTHH:mm"
            ? moment(new Date(item.ttdRecoverDate)).format("HH:mm")
            : null,
        modifiedBy: localStorage.getItem("User"),
      };
    });
    return obj;
  };

  const navigateBack = () => {
    navigate(
      `/home/searchrosters?classRequestId=${classRequestId}&classRosterId=${classRosterId}`,
    );
  };

  return (
    <>
      <Modal
        open={modalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={searchTrainerStyle}>
          <SearchModal
            onClose={(data, type) => handleSearchTrainerClose(data, type)}
            type={searchType}
          ></SearchModal>
        </Box>
      </Modal>
      {loading ? <BackdropComponent /> : null}
      <TableContainer className={classes.container} component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
                sx={{
                  minWidth: "320px !important",
                  maxWidth: 320,
                  position: "sticky",
                  left: 0,
                  top: "0 !important",
                  zIndex: "1100 !important",
                  boxShadow: "2px 0 5px -2px rgba(0,0,0,0.15)",
                  cursor: "pointer",
                  backgroundColor: "#e5e4e2 !important",
                }}
                onClick={() => sorting("Name")}
              >
                <span>{t("name")}</span>
                <Box sx={{ display: "inline-block" }}>
                  <ArrowUpwardIcon
                    sx={{
                      fontSize: 18,
                      color: order === "ASC" ? "#1976d2" : "#9e9e9e",
                      verticalAlign: "middle",
                    }}
                  />
                  <ArrowDownwardIcon
                    sx={{
                      fontSize: 18,
                      color: order === "DSC" ? "#1976d2" : "#9e9e9e",
                      verticalAlign: "middle",
                    }}
                  />
                </Box>
                <Typography
                  className={classes.blueColor}
                  sx={{ fontSize: "14px", margin: "0" }}
                >
                  Total: {totalActiveCount.total} | Active:{" "}
                  {totalActiveCount.active}
                </Typography>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <span>{t("Nesting Date/Time")}</span>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <TextField
                      size="small"
                      id="datetime-local"
                      type="datetime-local"
                      value={globalDate.NestingDate}
                      className={classes.timeInput}
                      onChange={(e) => {
                        handleGlobalDateChange(e.target.value, "NestingDate");
                      }}
                      onKeyDown={(e) =>
                        handleGlobalDateChange(
                          e.key === "Backspace" ? "" : e.target.value,
                          "NestingDate",
                        )
                      }
                      InputLabelProps={{
                        shrink: true,
                        inputFormat: "YYYY-MM-DD : HH:MM",
                      }}
                      fullWidth
                    />
                  </LocalizationProvider>
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("Nesting End Date/Time")}</span>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <TextField
                      size="small"
                      id="datetime-local"
                      type="datetime-local"
                      value={globalDate.NestingEndDate}
                      className={classes.timeInput}
                      onChange={(e) => {
                        handleGlobalDateChange(
                          e.target.value,
                          "NestingEndDate",
                        );
                      }}
                      onKeyDown={(e) =>
                        handleGlobalDateChange(
                          e.key === "Backspace" ? "" : e.target.value,
                          "NestingEndDate",
                        )
                      }
                      InputLabelProps={{
                        shrink: true,
                        inputFormat: "YYYY-MM-DD : HH:MM",
                      }}
                      fullWidth
                    />
                  </LocalizationProvider>
                </Box>
              </TableCell>

              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("FDO")}</span>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <TextField
                    size="small"
                    defaultValue="Search"
                    className={classes.textFieldContainer}
                    onKeyDown={(e) => handleOpenSearchTrainer("fdoGlobal")}
                    onChange={(e) => {
                      setGlobalValue({
                        OperationalTeamLeadName: e.target.value,
                      });
                      hanldeIndividualChange(e, "FDOTeamEmail");
                    }}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon
                            sx={{ cursor: "pointer", color: "##000000" }}
                            onClick={(e) =>
                              handleOpenSearchTrainer("fdoGlobal")
                            }
                          />
                          <CloseIcon
                            onClick={() => emptyAllSearchBox("fdoGlobal")}
                            sx={{ cursor: "pointer", color: "black" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    type={"fdoGlobal"}
                    fullWidth
                  ></TextField>
                  {globalValue.FDOName}
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("OG")}</span>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <TextField
                    size="small"
                    defaultValue="Search"
                    className={classes.textFieldContainer}
                    onKeyDown={(e) => handleOpenSearchTrainer("ogGlobal")}
                    onChange={(e) => hanldeIndividualChange(e, "OGTeamEmail")}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon
                            sx={{ cursor: "pointer", color: "##000000" }}
                            onClick={(e) => handleOpenSearchTrainer("ogGlobal")}
                          />
                          <CloseIcon
                            onClick={() => emptyAllSearchBox("ogGlobal")}
                            sx={{ cursor: "pointer", color: "black" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    type={"ogGlobal"}
                    fullWidth
                  ></TextField>
                  {globalValue.OGName}
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("OG Team Email")}</span>
                <TextField
                  multiline
                  rows={2.5}
                  className={classes.inputContainer}
                  aria-label="empty textarea"
                  value={globalValue.OGTeamEmail}
                  onChange={(e) => {
                    handlgeGlobalValue(e, "OGTeamEmail");
                  }}
                />
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("Ops Team Lead")}</span>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <TextField
                    size="small"
                    defaultValue="Search"
                    className={classes.textFieldContainer}
                    onKeyDown={(e) => handleOpenSearchTrainer("tpcGlobal")}
                    onChange={(e) => {
                      setGlobalValue({
                        OperationalTeamLeadName: e.target.value,
                      });
                      hanldeIndividualChange(e, "OperationalTeamLeadEmail");
                    }}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon
                            sx={{ cursor: "pointer", color: "##000000" }}
                            onClick={(e) =>
                              handleOpenSearchTrainer("tpcGlobal")
                            }
                          />
                          <CloseIcon
                            onClick={() => emptyAllSearchBox("tpcGlobal")}
                            sx={{ cursor: "pointer", color: "black" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    type={"tpcGlobal"}
                    fullWidth
                  ></TextField>
                  {globalValue.OperationalTeamLeadName}
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("Nesting Team Lead")}</span>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <TextField
                    size="small"
                    defaultValue="Search"
                    className={classes.textFieldContainer}
                    onKeyDown={(e) => handleOpenSearchTrainer("nstGlobal")}
                    onChange={(e) => {
                      setGlobalValue({ NestingTeamLead: e.target.value });
                      hanldeIndividualChange(e, "NestingTeamLeadEmail");
                    }}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon
                            sx={{ cursor: "pointer", color: "##000000" }}
                            onClick={(e) =>
                              handleOpenSearchTrainer("nstGlobal")
                            }
                          />
                          <CloseIcon
                            onClick={() => emptyAllSearchBox("nstGlobal")}
                            sx={{ cursor: "pointer", color: "black" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    type={"nstGlobal"}
                    fullWidth
                  ></TextField>
                  {globalValue.NestingTeamLead}
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("PTDateandTime")}</span>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <TextField
                      size="small"
                      id="datetime-local"
                      type="datetime-local"
                      value={globalDate.ProductTrainingDate}
                      sx={{ backgroundColor: "#fff" }}
                      onChange={(e) => {
                        handleGlobalDateChange(
                          e.target.value,
                          "ProductTrainingDate",
                        );
                      }}
                      onKeyDown={(e) =>
                        handleGlobalDateChange(
                          e.key === "Backspace" ? "" : e.target.value,
                          "ProductTrainingDate",
                        )
                      }
                      InputLabelProps={{
                        shrink: true,
                        inputFormat: "YYYY-MM-DD : HH:MM",
                      }}
                      fullWidth
                    />
                  </LocalizationProvider>
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("PTMeetingLink")}</span>
                <TextField
                  value={globalValue.ProductTrainingZoomLink}
                  name="ProductTrainingZoomLink"
                  className={classes.textFieldMeetingContainer}
                  inputProps={{ maxLength: 300 }}
                  type="text"
                  onChange={(e) => {
                    handlgeGlobalValue(e, "ProductTrainingZoomLink");
                  }}
                ></TextField>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("TTDType")}</span>
                <FormControl
                  sx={{
                    minWidth: 140,
                    marginTop: 10,
                    margin: "auto",
                    align: "center",
                    backgroundColor: "#fff",
                  }}
                  size="small"
                >
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={ttdTypeAll}
                    onChange={(e) => {
                      setTtdTypeAll(e.target.value);
                      handlgeGlobalValue(e, "TechTestType");
                    }}
                  >
                    {ttdType.map((item) => (
                      <MenuItem key={item} value={item}>
                        <b>{item}</b>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("ASDLead")}</span>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("FailureReason")}</span>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("TTD/BOTDate/Time")}</span>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <TextField
                      id="datetime-local"
                      type="datetime-local"
                      className={classes.timeInput}
                      value={globalDate.ttdDate}
                      onChange={(e) => {
                        handleGlobalDateChange(e.target.value, "ttdDate");
                      }}
                      onKeyDown={(e) =>
                        handleGlobalDateChange(
                          e.key === "Backspace" ? "" : e.target.value,
                          "ttdDate",
                        )
                      }
                      InputLabelProps={{
                        shrink: true,
                        inputFormat: "YYYY-MM-DD : HH:MM",
                      }}
                      fullWidth
                    />
                  </LocalizationProvider>
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("TTDMeetingLink")}</span>
                <TextField
                  value={globalValue.TechTestZoomLink}
                  name="TechTestZoomLink"
                  className={classes.textFieldMeetingContainer}
                  type="text"
                  onChange={(e) => {
                    handlgeGlobalValue(e, "TechTestZoomLink");
                  }}
                ></TextField>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("TTDRecoveryMeetingLink")}</span>
                <TextField
                  value={globalValue.TechTestRecoveryZoomLink}
                  name="TechTestRecoveryZoomLink"
                  className={classes.textFieldMeetingContainer}
                  type="text"
                  onChange={(e) => {
                    handlgeGlobalValue(e, "TechTestRecoveryZoomLink");
                  }}
                ></TextField>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("TTDRecoveryDate/Time")}</span>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <TextField
                      id="datetime-local"
                      type="datetime-local"
                      className={classes.timeInput}
                      value={globalDate.ttdRecoverDate}
                      onChange={(e) => {
                        handleGlobalDateChange(
                          e.target.value,
                          "ttdRecoverDate",
                        );
                      }}
                      onKeyDown={(e) =>
                        handleGlobalDateChange(
                          e.key === "Backspace" ? "" : e.target.value,
                          "ttdRecoverDate",
                        )
                      }
                      InputLabelProps={{
                        shrink: true,
                        inputFormat: "YYYY-MM-DD : HH:MM",
                      }}
                      fullWidth
                    />
                  </LocalizationProvider>
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("WorkedHours")}</span>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
              >
                <span>{t("RecoveryWorkedHours")}</span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {classData.length > 0 &&
              classData.map((row, i) => {
                const rowKey = `${row.OracleId}-${i}`;
                return (
                  <TableRow key={rowKey}>
                    <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                        boxShadow: "2px 0 5px -2px rgba(0,0,0,0.15)",
                      }}
                    >
                      {/* Individual Row Cells */}
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        columns={1}
                        alignItems="center"
                        spacing={0}
                      >
                        {renderTextCell(
                          `${row.Name} (${row.OracleId})`,
                          row.TraineeStatus,
                          row.TraineeStatus !== "Active",
                        )}
                        {row.TTECRegistrationStatus ? (
                          <Grid item xs={0.1}>
                            <Tooltip title="TTEConnect: Registered">
                              <PowerSharpIcon
                                placeholder="TTEConnect: Registered"
                                sx={{ color: "#69DE00" }}
                              />
                            </Tooltip>
                          </Grid>
                        ) : (
                          <Grid item xs={0.1}></Grid>
                        )}
                        <LastUpdateTooltip
                          AgentCommentsModifiedDate={
                            row.AgentCommentsModifiedDate
                          }
                          AgentCommentsModifiedBy={row.AgentCommentsModifiedBy}
                        >
                          <textarea
                            className={classes.agentCommentInputContainer}
                            value={row.AgentComments ? row.AgentComments : ""}
                            maxLength={4000}
                            placeholder="Max 4000 characters allowed"
                            onChange={(e) =>
                              handleIndividualText(e, row, "AgentComments")
                            }
                            style={{ width: "100%", minWidth: "350px" }}
                          ></textarea>
                        </LastUpdateTooltip>
                      </Grid>
                    </TableCell>

                    {/* Other Cells */}
                    <TableCell align="center" sx={{ pl: 2 }}>
                      <TextField
                        size="small"
                        id="datetime-local"
                        type="datetime-local"
                        value={row.NestingDate}
                        className={classes.timeInput}
                        onChange={(e) =>
                          handleIndividualDateChange(
                            e.target.value === ""
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "NestingDate",
                          )
                        }
                        onKeyDown={(e) =>
                          handleIndividualDateChange(
                            e.key === "Backspace"
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "NestingDate",
                          )
                        }
                        InputLabelProps={{
                          shrink: true,
                          inputFormat: "YYYY-MM-DD : HH:MM",
                        }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell align="center" sx={{ pl: 2 }}>
                      <TextField
                        size="small"
                        id="datetime-local"
                        type="datetime-local"
                        value={row.NestingEndDate}
                        className={classes.timeInput}
                        onChange={(e) =>
                          handleIndividualDateChange(
                            e.target.value === ""
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "NestingEndDate",
                          )
                        }
                        onKeyDown={(e) =>
                          handleIndividualDateChange(
                            e.key === "Backspace"
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "NestingEndDate",
                          )
                        }
                        InputLabelProps={{
                          shrink: true,
                          inputFormat: "YYYY-MM-DD : HH:MM",
                        }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell align="center" sx={{ pl: 2 }}>
                      <Box>
                        <TextField
                          size="small"
                          defaultValue="Search"
                          sx={{ backgroundColor: "#fff", width: 200 }}
                          onClick={(e) =>
                            handleOpenSearchTrainerIndividual(
                              "fdoSingle",
                              i,
                              row.OracleId,
                              row.TraineeStatus,
                            )
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                          type={"fdoSingle"}
                          fullWidth
                        ></TextField>
                        {row.FDOName}
                        <br />
                        {row.FDOEmail}
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ pl: 2 }}>
                      <Box>
                        <TextField
                          size="small"
                          defaultValue="Search"
                          sx={{ backgroundColor: "#fff", width: 200 }}
                          onClick={(e) =>
                            handleOpenSearchTrainerIndividual(
                              "ogSingle",
                              i,
                              row.OracleId,
                              row.TraineeStatus,
                            )
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                          type={"ogSingle"}
                          fullWidth
                        ></TextField>
                        {row.OGName}
                        <br />
                        {row.OGEmail}
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ pl: 2 }}>
                      <TextField
                        multiline
                        rows={2.5}
                        fullWidth
                        className={classes.inputContainer}
                        aria-label="empty textarea"
                        value={row.OGTeamEmail === null ? "" : row.OGTeamEmail}
                        onChange={(e) =>
                          hanldeIndividualChange(e, row, "OGTeamEmail")
                        }
                      />
                    </TableCell>
                    <TableCell align="center" sx={{ pl: 2 }}>
                      <Box>
                        <TextField
                          size="small"
                          defaultValue="Search"
                          sx={{ backgroundColor: "#fff", width: 200 }}
                          onClick={(e) =>
                            handleOpenSearchTrainerIndividual(
                              "tpcSingle",
                              i,
                              row.OracleId,
                              row.TraineeStatus,
                            )
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                          type={"tpcSingle"}
                          fullWidth
                        ></TextField>
                        {row.OperationalTeamLead}
                        <br />
                        {row.OperationalTeamLeadEmail}
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ pl: 2 }}>
                      <Box>
                        <TextField
                          size="small"
                          defaultValue="Search"
                          sx={{ backgroundColor: "#fff", width: 200 }}
                          onClick={(e) =>
                            handleOpenSearchTrainerIndividual(
                              "nstSingle",
                              i,
                              row.OracleId,
                              row.TraineeStatus,
                            )
                          }
                          InputProps={{
                            readOnly: true,
                          }}
                          type={"nstSingle"}
                          fullWidth
                        ></TextField>
                        {row.NestingTeamLead}
                        <br />
                        {row.NestingTeamLeadEmail}
                      </Box>
                    </TableCell>

                    <TableCell align="center">
                      <TextField
                        size="small"
                        id="datetime-local"
                        type="datetime-local"
                        value={row.ProductTrainingDate}
                        className={classes.timeInput}
                        onChange={(e) =>
                          handleIndividualDateChange(
                            e.target.value === ""
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "ProductTrainingDate",
                          )
                        }
                        onKeyDown={(e) =>
                          handleIndividualDateChange(
                            e.key === "Backspace"
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "ProductTrainingDate",
                          )
                        }
                        InputLabelProps={{
                          shrink: true,
                          inputFormat: "YYYY-MM-DD : HH:MM",
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip
                        title={
                          row.ProductTrainingZoomLink === null
                            ? ""
                            : row.ProductTrainingZoomLink
                        }
                        arrow
                      >
                        <TextField
                          value={
                            row.ProductTrainingZoomLink === null
                              ? ""
                              : row.ProductTrainingZoomLink
                          }
                          name="ProductTrainingZoomLink"
                          className={classes.textFieldContainer}
                          type="text"
                          fullWidth
                          inputProps={{ maxLength: 300 }}
                          onChange={(e) =>
                            hanldeIndividualChange(
                              e,
                              row,
                              "ProductTrainingZoomLink",
                            )
                          }
                        ></TextField>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      className={"text-center align-center"}
                      align="center"
                    >
                      <FormControl
                        sx={{
                          width: 140,
                          marginTop: 10,
                          margin: "auto",
                          align: "center",
                          backgroundColor: "#fff",
                        }}
                        size="small"
                      >
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="TTDType"
                          value={
                            row.TechTestType === null ? "" : row.TechTestType
                          }
                          onChange={(e) =>
                            hanldeIndividualChange(e, row, "TechTestType")
                          }
                        >
                          {ttdType.map((value, index) => (
                            <MenuItem key={value} value={value}>
                              <b>{value}</b>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>

                    <TableCell align="center">
                      <Tooltip title={row.ASDLead || ""}>
                        <TextField
                          name="ASDLead"
                          value={row.ASDLead || ""}
                          onChange={(e) =>
                            hanldeIndividualChange(e, row, "ASDLead")
                          }
                          variant="outlined"
                          size="small"
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title={row.FailureReason || ""}>
                        <TextField
                          name="FailureReason"
                          value={row.FailureReason || ""}
                          onChange={(e) =>
                            hanldeIndividualChange(e, row, "FailureReason")
                          }
                          variant="outlined"
                          size="small"
                        />
                      </Tooltip>
                    </TableCell>

                    <TableCell align="center">
                      <TextField
                        id="datetime-local"
                        type="datetime-local"
                        value={row.ttdDate}
                        className={classes.timeInput}
                        onChange={(e) =>
                          handleIndividualDateChange(
                            e.target.value === ""
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "ttdDate",
                          )
                        }
                        onKeyDown={(e) =>
                          handleIndividualDateChange(
                            e.key === "Backspace"
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "ttdDate",
                          )
                        }
                        InputLabelProps={{
                          shrink: true,
                          inputFormat: "YYYY-MM-DD : HH:MM",
                        }}
                      />
                    </TableCell>

                    <TableCell align="center">
                      <Tooltip
                        title={
                          row.TechTestZoomLink === null
                            ? ""
                            : row.TechTestZoomLink
                        }
                        arrow
                      >
                        <TextField
                          value={
                            row.TechTestZoomLink === null
                              ? ""
                              : row.TechTestZoomLink
                          }
                          name="TechTestZoomLink"
                          className={classes.textFieldContainer}
                          type="text"
                          fullWidth
                          inputProps={{ maxLength: 300 }}
                          onChange={(e) =>
                            hanldeIndividualChange(e, row, "TechTestZoomLink")
                          }
                        ></TextField>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip
                        title={
                          row.TechTestRecoveryZoomLink === null
                            ? ""
                            : row.TechTestRecoveryZoomLink
                        }
                        arrow
                      >
                        <TextField
                          value={
                            row.TechTestRecoveryZoomLink === null
                              ? ""
                              : row.TechTestRecoveryZoomLink
                          }
                          name="TechTestRecoveryZoomLink"
                          className={classes.textFieldContainer}
                          type="text"
                          fullWidth
                          inputProps={{ maxLength: 300 }}
                          onChange={(e) =>
                            hanldeIndividualChange(
                              e,
                              row,
                              "TechTestRecoveryZoomLink",
                            )
                          }
                        ></TextField>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        id="datetime-local"
                        type="datetime-local"
                        value={row.ttdRecoverDate}
                        className={classes.timeInput}
                        onChange={(e) =>
                          handleIndividualDateChange(
                            e.target.value === ""
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "ttdRecoverDate",
                          )
                        }
                        onKeyDown={(e) =>
                          handleIndividualDateChange(
                            e.key === "Backspace"
                              ? "YYYY-MM-DDTHH:mm"
                              : e.target.value,
                            row,
                            "ttdRecoverDate",
                          )
                        }
                        InputLabelProps={{
                          shrink: true,
                          inputFormat: "YYYY-MM-DD : HH:MM",
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <span>{row.WorkedHoursTechTest}</span>
                    </TableCell>
                    <TableCell align="center">
                      <span>{row.WorkedHoursTechTestRecovery}</span>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* SnackBar Component */}
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
      {/* Buttons */}
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingTop: 2,
          gap: 1,
        }}
      >
        <CustomOutlinedButton variant="outlined" onClick={navigateBack}>
          {t("CANCEL")}
        </CustomOutlinedButton>
        <CustomButton onClick={(e) => saveClassData(e)}>
          {t("SAVE")}
        </CustomButton>
        <CustomButton onClick={(e) => saveCloseHandler(e)}>
          {t("SAVE+CLOSE")}
        </CustomButton>
      </Grid>
    </>
  );
};

ClassData.prototype = {
  filterStatus: PropTypes.string,
  closeLoader: PropTypes.func,
  resetStatus: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ClassData;
